import './about.css';
import image from '../../assets/flyer.jpeg'
import Card from '../../components/Card'
import data from './data'

const About = () => {
  return (
   <section id="about">
     <h2>About Our 360 Photo/Video Booth</h2>
     <div className="container about__container">
  
    <p> Have you been looking to add fun and excitement to your next event? Worry no more! Just hit the button below, let’s help you add amazing fun to that your event using our trendy and game-changing 360 photo booth spinner also known as slow-motion video booth.
</p>

<p>
  
Photo or camera video booth offer a wow and memorable experience for you and the guests attending you events.  360 video spinner booth will boost the fun at your parties, wedding, pre-wedding shoots, engagement, birthdays, concerts, movie premieres, cinemas, entertainment shows, awards ceremonies, conferences, seminars, sport events, corporate events fashion show.
360 Video spinner is suitable for kids, adult’s individuals, groups, corporate organizations and it can be customized for your event’s theme. 


</p>

<p>
We provide and elevated and motorized 360 spinner video platform that your guest can stand on, and a safety arm attached to the 360 spinner video platform spins around to capture high quality slow-motion footage from all angles. Our 360 video booth boast of exceptional features and modern technology that allow organizers, guest couples and friend to share timeless, fun and playful slow-motion video footage on social media platforms.
</p>




           

      
     </div>
    <div className='hire'>
    <div className='underline'></div>
    <a href="#footer" className='btn primary'>Hire Now</a>
      <div className='underline'></div>
    </div>
   </section>
  )
}

export default About